<template>
  <div class="ys_apply">
    <div class="yssq_table">
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            ref="search"
            style="display: flex; height: 39px"
            :model="searchForm"
            label-width="90px"
            label-position="left"
          >
            <el-form-item label="省份:" label-width="60px">
              <el-select v-model="searchForm.province" clearable placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="销售企业:">
              <el-input
                v-model="searchForm.company"
                placeholder="请输入"
              />
            </el-form-item>
            <el-button
              v-preventReClick
              type="primary"
              class="sousuoButton"
              size="small"
              round
              icon="el-icon-search"
              @click="handleCurrentChange(1)"
            >搜索</el-button>
          </el-form>
        </div>
      </div>
      <div
        style="
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 57px;
        "
      >
        <div class="tablemes">
          <el-table ref="yssqTable" :data="tableData" border
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
          >
            <el-table-column>
              <template slot="header">
                <el-button v-preventReClick size="mini" class="deleteButton" icon="el-icon-upload" @click="daochu">导出</el-button>
              </template>
              <el-table-column align="center" show-overflow-tooltip prop="xkzBh" label="许可证编号"></el-table-column>
              <el-table-column align="center" show-overflow-tooltip prop="hxpMc" label="化学品"></el-table-column>
              <el-table-column align="center" show-overflow-tooltip prop="xsdwMc" label="销售单位"></el-table-column>
              <el-table-column align="center" show-overflow-tooltip prop="xsdwTyshxydm" label="信用代码"></el-table-column>
              <el-table-column align="center" show-overflow-tooltip prop="xsdwPro" label="行政区划"></el-table-column>
              <el-table-column align="center" show-overflow-tooltip prop="gmdwMc" label="购买单位"></el-table-column>
              <el-table-column align="center" show-overflow-tooltip prop="gmdwTyshxydm" label="信用代码"></el-table-column>
              <el-table-column align="center" show-overflow-tooltip prop="gmdwPro" label="行政区划"></el-table-column>
              <el-table-column align="center" show-overflow-tooltip prop="ztLabel" label="状态"></el-table-column>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :page-sizes="[10, 20, 30, 40]"
            :total="total"
            :page-size="pagesize"
            class="el-page"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { excelwriterGmByHxWhc, getGmByHxWhc, getXzqTree } from '@/assets/js/hxwhc'
export default {
  props: {},
  data() {
    return {
      hxBeforeFlag: false,
      leixing: '',
      content: {},
      titleText: '',
      dialogVisible: false,
      table: [{
        key: 'xkzBh',
        label: '许可证编号'
      }, {
        key: 'hxpMc',
        label: '化学品'
      }],
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      searchForm: {
        province: '', // 省
        company: '' // 公司
      },

      multipleSelection: [],
      options: [],
      URL1: ''
    }
  },
  computed: {},
  watch: {},
  created() {
    getXzqTree().then((res) => {
      this.options = res.data.data
    })
  },
  mounted() {
  },

  beforeDestroy() {},
  methods: {
    // 搜索
    sousuo() {
      this.getTableData()
    },
    // 导出
    daochu() {
      excelwriterGmByHxWhc(this.searchForm).then((e) => {
        console.log(e)
        const table = '购买证'
        const a = document.createElement('a')
        const blob = new Blob([e.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.getTableData()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.getTableData()
    },
    getTableData() {
      getGmByHxWhc({
        param: this.searchForm,
        page: this.currentPage,
        size: this.pagesize
      }).then((e) => {
        console.log(e.data.data)
        this.tableData = e.data.data.records
        this.total = e.data.data.total
      })
    }
  }
}
</script>
<style scoped lang='less'>
/deep/.el-form--inline .el-form-item__content {
  display: inline-block;
  vertical-align: middle !important;
}
/deep/.el-table--border {
  border-right: none;
  border-bottom: none;
  z-index: 0 !important;
}
.ys_apply {
  .headerSearch {
    max-width: 1518px;
    height: 96px;
    margin-bottom: 10px;
    margin-top: 35px;
    background-color: white;
    // padding: 30px 0 20px 0;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        width: 90px;
        height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .yssq_table {
    width: 95%;
    max-width: 1503px;
    // min-width: 1100px;
    margin: auto;
  }
  /deep/.el-table .cell,
  /deep/.el-table--border td:first-child .cell,
  /deep/.el-table--border th:first-child .cell {
    padding-left: 8px !important;
  }
  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 1px solid #ebeef5;
    text-align: center;
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;

    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-radius: 20px;
      border-color: #4170ff;
    }
    /deep/ .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      // &:last-child {
      //   // width: 90px;
      //   height: 39px;
      // }
    }
  }
  .tablemes {
    width: 90%;
    margin: auto;
    max-width: 1375px;
    // margin-top: 21px;
    // margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;
      border: 1px solid #ebeef5;
      border-top: 0;
    }
    // .addButton {
    //   color: #fff;
    //   background: #4170ff;
    //   border-radius: 3px;
    //   border-color: #4170ff;
    // }
    .el-button--warning {
      color: #fff;
      background: #fe5622;
      border-radius: 3px;
      border-color: #fe5622;
    }
    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }

    .shanchu {
      border-color: #ff4c00;
      background: #ff4c00;
      color: #fff;
      width: 65px;
      padding: 7px 9px;
    }
  }
  .el-page {
    // width: 90px;
    // height: 39px;
    .el-pager {
      .active {
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/ .has-gutter {
  .el-checkbox {
    display: none;
  }
}
</style>
